import Text from 'components/Text/Text';
import React, { useContext, useEffect } from 'react';
import {
	IEditRestaurantContext,
	EditRestaurantContext,
} from '../../../../../editRestaurantState/editRestaurantContext';
import { IWatchesContext, WatchesContext } from '../watchesState/watchesContext';
import { Form } from 'antd';
import WatchesQuantityField from './components/WatchesQuantityField';
import AdminWatchesQuantityField from './components/AdminWatchesQuantityField';
import CommandsMultipleSelect from './components/CommandsMultipleSelect';
import DownloadFileBtn from './components/DownloadFileBtn';
import Watches from './components/Watches';
import AdminWatches from './components/AdminWatches';
import BtnBlock from './components/BtnBlock';
import { preventDefaultForEnterKey } from 'utils/helpers';
import style from './InputFields.module.scss';

const InputFields: React.FC = () => {
	const { restaurantId, generatedWatchCommandsLink } = useContext<IEditRestaurantContext>(EditRestaurantContext);
	const {
		changeTypeOfModalWindow,
		setDataForSubmit,
		setWatchesQuantity,
		setAdminWatchesQuantity,
		setCommands,
		changeWatchesTableRanges,
		changeAdminWatchesTableRanges,
		watchesQuantity,
		adminWatchesQuantity,
		commands,
		watchesTableRanges,
		adminWatchesTableRanges,
	} = useContext<IWatchesContext>(WatchesContext);
	const [form] = Form.useForm();

	useEffect(() => {
		form.setFieldsValue({ watchesQuantity });
		form.setFieldsValue({ adminWatchesQuantity });
		form.setFieldsValue({ commands });
		watchesTableRanges.forEach((el) => form.setFieldsValue({ [el.id]: el.range }));
	}, [watchesQuantity, adminWatchesQuantity, commands, watchesTableRanges]);

	const submit = async () => {
		setDataForSubmit({
			restaurantID: restaurantId,
			data: {
				watchesQuantity: Number(watchesQuantity),
				adminWatchesQuantity: Number(adminWatchesQuantity),
				watchesCommands: commands,
				watchesTableRanges: watchesTableRanges.map((el) => el.range),
				adminWatchesTableRanges: adminWatchesTableRanges.length ? adminWatchesTableRanges[0].range : null,
			},
		});
		changeTypeOfModalWindow('toConfirmSubmit');
	};

	return (
		<div className={style.container} data-test="InputFields">
			<Form form={form} name="basic" onFinish={submit} onKeyPress={preventDefaultForEnterKey} layout="vertical">
				<div className={style.fieldsWrapper}>
					<Text
						translationNameSpace="form"
						translationKey="infoHeading"
						theme="secondary"
						size="l"
						weight="bold"
						display="inline"
					/>
					<div className={style.row}>
						<WatchesQuantityField setWatchesQuantity={setWatchesQuantity} />
						<AdminWatchesQuantityField setAdminWatchesQuantity={setAdminWatchesQuantity} />
					</div>
					<CommandsMultipleSelect setCommands={setCommands} />
					<DownloadFileBtn generatedWatchCommandsLink={generatedWatchCommandsLink} />
				</div>
				{watchesTableRanges.length || adminWatchesTableRanges.length ? (
					<div className={style.fieldsWrapper}>
						<Text
							translationNameSpace="form"
							translationKey="tableRangesHeading"
							theme="secondary"
							size="l"
							weight="bold"
							display="inline"
						/>
						{watchesTableRanges.length ? (
							<div>
								<span className={style.inputDescription}>Watches</span>
								<Watches
									changeWatchesTableRanges={changeWatchesTableRanges}
									watchesTableRanges={watchesTableRanges}
								/>
							</div>
						) : null}
						{adminWatchesTableRanges.length ? (
							<div>
								<span className={style.inputDescription}>Admin watches</span>
								<AdminWatches
									changeAdminWatchesTableRanges={changeAdminWatchesTableRanges}
									adminWatchesTableRanges={adminWatchesTableRanges}
								/>
							</div>
						) : null}
					</div>
				) : null}
				<BtnBlock />
			</Form>
		</div>
	);
};

export default InputFields;
